var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsTrashOutlinedWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6V5a3 3 0 013-3h4a3 3 0 013 3v1h3a1 1 0 010 2v11a3 3 0 01-3 3H7a3 3 0 01-3-3V8a1 1 0 110-2h3zm2 0h6V5a1 1 0 00-1-1h-4a1 1 0 00-1 1v1zm9 2H6v11a1 1 0 001 1h10a1 1 0 001-1V8zm-9 3a1 1 0 012 0v6a1 1 0 01-2 0v-6zm4 0a1 1 0 012 0v6a1 1 0 01-2 0v-6z",
    fill: "#FFF"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGwtcnVsZT0ibm9uemVybyIgZmlsbD0ibm9uZSI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik03IDZWNWEzIDMgMCAwIDEgMy0zaDRhMyAzIDAgMCAxIDMgM3YxaDNhMSAxIDAgMCAxIDAgMnYxMWEzIDMgMCAwIDEtMyAzSDdhMyAzIDAgMCAxLTMtM1Y4YTEgMSAwIDEgMSAwLTJoM3ptMiAwaDZWNWExIDEgMCAwIDAtMS0xaC00YTEgMSAwIDAgMC0xIDF2MXptOSAySDZ2MTFhMSAxIDAgMCAwIDEgMWgxMGExIDEgMCAwIDAgMS0xVjh6bS05IDNhMSAxIDAgMCAxIDIgMHY2YTEgMSAwIDAgMS0yIDB2LTZ6bTQgMGExIDEgMCAwIDEgMiAwdjZhMSAxIDAgMCAxLTIgMHYtNnoiIGZpbGw9IiNGRkYiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgIconsTrashOutlinedWhite as ReactComponent };